/**
 * 在线学习模块API
 */
import http from './http.js';

export default class StudyApi {
	//获取课程分类
    static getClassify (params) {
        return http.httpGet('study/list',params);
    }
    //获取课程列表
    static getCourse (id) {
        return http.httpGet('study/course', {id});
    }
    //获取课程的所有标签
    static getAllLabel (id) {
        return http.httpPost('study/getAllLabel', {id});
    }
    //添加点击课程统计
    static addCourseCount (params) {
        return http.httpPost('study/addCourseCount',params);
    }
    //获取课程详细内容
    static getCourseDetail (id) {
        return http.httpGet('study/courseDetail', {id});
    }
    //获取讲师信息
    static getTeacher (id) {
        return http.httpGet('study/teacher', {id});
    }
    //获取课时列表
    static getPeriod (id) {
        return http.httpGet('study/period', {id});
    }
    //获取该讲师下的所有课程
    static getTeacherCourse(params) {
        return http.httpPost('study/getTeacherCourse',params);
    }
    //获取金牌讲师
    static getGlodTeacher(params) {
        return http.httpPost('study/getGlodTeacher',params);
    }
    //获取课程排行榜
    static getRankingCourse() {
        return http.httpPost('study/getRankingCourse');
    }

    //获取单个课时信息
    static getLesson (id) {
        return http.httpGet('study/lesson', {id});
    }
    //获取学习时长和考试排名
    static getUserStudy (id) {
        return http.httpPost('study/getUserStudy', {id});
    }

    //添加课程笔记
    static addNote (courseId, content) {
        return http.httpPost('study/note', {courseId, content});
    }
    //获取课程笔记
    static getNote (courseId) {
        return http.httpGet('study/note', {courseId});
    }
    //添加播放历史记录
    static addHistory (params) {
        return http.httpPost('study/history', params);
    }
    //获取用户播放历史记录
    static getHistory (params) {
        return http.httpGet('study/history',params);
    }
    // 获取在线学习勤奋上进榜
    static getStudyTops (limit) {
        return http.httpGet('study/tops', {limit});
    }
    // 增加视频播放时长
    static addTime (params) {
        return http.httpPost('study/addTime', params);
    }
    //获取推荐库
    static getRecommendFilterList (params) {
        return http.httpGet('study/getRecommendFilterList', params);
    }


}



// WEBPACK FOOTER //
// ./app/api/study.api.js